var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative img-container"},[_c('img',{staticClass:"position-absolute",attrs:{"src":`/images/cycle_dashboard_icon_${_vm.cycle.started ? _vm.cycle.is_current? 'white': 'blue' : 'gray'}.svg`}}),_vm._v(" "),_c('span',{staticClass:"position-absolute",class:{
      'theme--text' : _vm.cycle.started
    }},[_vm._v("\n    "+_vm._s(_vm.cycle.order)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }